export default "__VITE_ASSET__CoJqu4pT__"